
export class Suite {
    constructor(
        public id: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = ''
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Suite.ts